export default __webpack_public_path__ + "static/media/7080Page_en.f5eeb761.jpg";